import React from 'react';
import { Spin, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const { Text } = Typography;

const LoadingScreen = ({ message = '正在加载...' }) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 48, color: '#285C4D' }} spin />;

  return (
    <div className="loading-screen">
      <div className="loading-content">
        <div className="loading-icon">
          <span className="loading-emoji">🦷</span>
          <Spin indicator={antIcon} />
        </div>
        <Text className="loading-text">{message}</Text>
        <div className="loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      
      <style jsx>{`
        .loading-screen {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          min-height: 100vh;
          background: linear-gradient(135deg, #6FC232 0%, #6FC232 100%);
          color: white;
          text-align: center;
        }
        
        .loading-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 24px;
        }
        
        .loading-icon {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .loading-emoji {
          font-size: 60px;
          position: absolute;
          animation: bounce 2s infinite;
          z-index: 1;
        }
        
        .loading-text {
          font-size: 18px;
          color: rgba(255, 255, 255, 0.9);
          font-weight: 500;
        }
        
        .loading-dots {
          display: flex;
          gap: 8px;
        }
        
        .loading-dots span {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.6);
          animation: wave 1.4s infinite ease-in-out;
        }
        
        .loading-dots span:nth-child(1) {
          animation-delay: -0.32s;
        }
        
        .loading-dots span:nth-child(2) {
          animation-delay: -0.16s;
        }
        
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-10px);
          }
          60% {
            transform: translateY(-5px);
          }
        }
        
        @keyframes wave {
          0%, 60%, 100% {
            transform: initial;
          }
          30% {
            transform: translateY(-15px);
          }
        }
      `}</style>
    </div>
  );
};

export default LoadingScreen;
